import React, { useContext } from 'react';
import { ReactComponent as DescIcon } from '../../../assets/icons/angle-down-solid.svg';
import { ReactComponent as AscIcon } from '../../../assets/icons/angle-up-solid.svg';
import { SearchContext } from '../../../context/Search';
import classes from './index.module.scss';

const SortButton = ({ name, sortBy, setSortedBy, sortedBy }) => {
  const { setSorted, setOffset, setOrderByParams, orderByParams } = useContext(SearchContext);

  const setDefaultSort = () => {
    let newSortedBy = {...sortedBy};
    Object.keys(newSortedBy).forEach(v => newSortedBy[v] = null);
    return newSortedBy;
  }

  const sortHandler = () => {
    setSortedBy({
      ...setDefaultSort(),
      [sortBy]: !sortedBy[sortBy]
    });
    setSorted(true);
    setOffset(0);
    setOrderByParams([`${sortBy}|${!sortedBy[sortBy] === true ? "asc" : "desc"}`]);
  }

  return (
    <th 
      className={`${classes.No_Wrap} ${classes.Sort_Btn}`}
    >
      <div className="d-flex align-items-center">
        <p className="mb-0">{name}</p>
        <div 
          className={classes.Sort_Icon_Wrap}
          onClick={sortHandler}
        >
          <AscIcon 
            className={classes.Sort_Icon}
            fill={sortedBy[sortBy] === true && orderByParams.length ? "#B69D73" : ""}
          />
          <DescIcon 
            className={classes.Sort_Icon}
            fill={sortedBy[sortBy] === false && orderByParams.length ? "#B69D73" : ""}
          />
        </div>
      </div>
    </th>
  )
}

export default SortButton;